import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddWidgetAccordion from 'InpageEditorUI/components/sidebar/add/AddWidgetAccordion';
import SearchResults from './SearchResults';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getCategoryDisplayNameByType } from 'ContentEditorUI/redux/selectors/categorizationSelectors';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES, PATAGONIA_ADD_PANEL_SUB_CATEGORIES_YAML_MAPPING } from 'ContentEditorUI/constants/Sidebar';
import MobileSidebarOverlayContainer from 'ContentEditorUI/components/sidebar/MobileSidebarOverlayContainer';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getUpgradableModulesWithPQL } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { getPatagoniaAddSidebarSubCategories } from 'ContentEditorUI/redux/selectors/sidebarCategorySelectors';
import useAccordionOpenState from 'ContentEditorUI/hooks/useAccordionOpenState';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TitleWrapper = styled.span.withConfig({
  displayName: "PatagoniaAddWidget__TitleWrapper",
  componentId: "sc-1oq4arp-0"
})([".hs-private.hs-private.hs-private &{font-size:14px;}"]);
const AccordionTitle = ({
  collectionCount,
  patagoniaAddSidebarSubCategory
}) => {
  const categoryDisplayNameByType = useSelector(getCategoryDisplayNameByType);
  const isAll = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
  const isTheme = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.THEME;
  return /*#__PURE__*/_jsx(TitleWrapper, {
    children: isAll || isTheme ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: PATAGONIA_ADD_PANEL_SUB_CATEGORIES_YAML_MAPPING[`${patagoniaAddSidebarSubCategory}_WITH_COUNT`],
      options: {
        count: collectionCount
      }
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: `${categoryDisplayNameByType[patagoniaAddSidebarSubCategory]} (${collectionCount})`
    })
  });
};
const AddWidgetAccordionWithOpenState = _ref => {
  let {
      type
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const storageKey = `addPanelAccordion-${type}.isOpen`;
  function getInitialOpenState(storedOpenState) {
    return Boolean(type === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.THEME && storedOpenState === null || storedOpenState && storedOpenState === 'true');
  }
  const {
    isOpen,
    handleOpenChange
  } = useAccordionOpenState({
    storageKey,
    getInitialOpenState
  });
  return /*#__PURE__*/_jsx("div", {
    className: "p-x-1 m-bottom-5",
    children: /*#__PURE__*/_jsx(AddWidgetAccordion, Object.assign({}, rest, {
      type: type,
      open: isOpen,
      onOpenChange: handleOpenChange
    }))
  });
};
const mapStateToProps = state => {
  return {
    isInNonDefaultBreakpointMode: getIsInNonDefaultBreakpointMode(state),
    categorizedSearchQuery: getSidebarSearchQuery(state),
    patagoniaAddSidebarSubCategories: getPatagoniaAddSidebarSubCategories(state),
    upgradableModules: getUpgradableModulesWithPQL(state)
  };
};
const PatagoniaAddWidget = ({
  categorizedSearchQuery,
  categoryToModulesSchemasMap,
  isInNonDefaultBreakpointMode,
  sidebarSearchResultsMap,
  onDragStart,
  onDragEnd,
  sidebarIframeBody,
  patagoniaAddSidebarSubCategories,
  shouldRenderTourStep,
  upgradableModules
}) => {
  function getCategorizedModules(sidebarSubCategory) {
    return categoryToModulesSchemasMap[sidebarSubCategory] || [];
  }
  const className = "expanding-sidebar hs-patagonia-editor" + (isInNonDefaultBreakpointMode ? " mobile-editing-mode" : "");
  return /*#__PURE__*/_jsxs("div", {
    className: `${className} layout-add-widget patagonia-inpage-add-module-sidebar on-dark p-x-2 p-y-5 `,
    "data-onboarding": "add-widget",
    children: [/*#__PURE__*/_jsx(MobileSidebarOverlayContainer, {
      modalMessageKey: "addModule.mobile.message.addModule",
      overlayClassName: "add-module-sidebar-mobile-overlay"
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [!categorizedSearchQuery && /*#__PURE__*/_jsx(_Fragment, {
        children: patagoniaAddSidebarSubCategories.MODULES.map(patagoniaAddSidebarSubCategory => {
          const collection = getCategorizedModules(patagoniaAddSidebarSubCategory);
          return /*#__PURE__*/_jsx(AddWidgetAccordionWithOpenState, {
            type: patagoniaAddSidebarSubCategory,
            sidebarIframeBody: sidebarIframeBody,
            collection: collection,
            title: /*#__PURE__*/_jsx(AccordionTitle, {
              collectionCount: collection.length,
              patagoniaAddSidebarSubCategory: patagoniaAddSidebarSubCategory
            }),
            onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            shouldRenderTourStep: shouldRenderTourStep,
            upgradableModules: upgradableModules
          }, patagoniaAddSidebarSubCategory);
        })
      }), categorizedSearchQuery && /*#__PURE__*/_jsx(SearchResults, {
        categoryToModulesSchemasMap: categoryToModulesSchemasMap,
        categorizedSearchQuery: categorizedSearchQuery,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        sidebarIframeBody: sidebarIframeBody,
        sidebarSearchResultsMap: sidebarSearchResultsMap
      })]
    })]
  });
};
PatagoniaAddWidget.propTypes = {
  onDragEnd: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  sidebarIframeBody: PropTypes.object.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  category: PropTypes.string,
  categorizedSearchQuery: PropTypes.string,
  categoryToModulesSchemasMap: PropTypes.object,
  sidebarSearchResultsMap: PropTypes.object
};
export default connect(mapStateToProps)(PatagoniaAddWidget);